export class Timer {
  constructor(tick = 1000) {
    this._tick = tick;
    this._timer = null;
    this._onTickHandlers = new Set();
    this._onStopHandler = () => {};
  }

  _executeHandlers = () => {
    this._onTickHandlers.forEach((fn) => typeof fn === "function" && fn());
  };

  _onTick = () => {
    this._executeHandlers(); // ❯❯ ticks until you call stop()
  };

  start = () => {
    if (this._timer) return;
    this._timer = setInterval(this._onTick, this._tick);
  };

  stop = () => {
    if (this._timer) clearInterval(this._timer);
    this._timer = null;
    const cb = this._onStopHandler;
    this._onStopHandler = () => {};
    cb();
  };

  setOnStopHeandler = (fn) => {
    this._onStopHandler = typeof fn === "function" ? fn : () => {};
  };

  addTickHeandler = (fn) => {
    if (typeof fn === "function") this._onTickHandlers.add(fn);
  };

  clearTickHandlers = () => {
    this._onTickHandlers.clear();
  };
}
